import omit from 'lodash/omit'

export const GithubIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 20}
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...omit(props, 'fill')}
  >
    <path
      d="M10.001 0C8.68776 0 7.3874 0.258658 6.17414 0.761205C4.96089 1.26375 3.85849 2.00035 2.92991 2.92893C1.05454 4.8043 0.000976563 7.34784 0.000976562 10C0.000976563 14.42 2.87098 18.17 6.84098 19.5C7.34098 19.58 7.50098 19.27 7.50098 19V17.31C4.73098 17.91 4.14098 15.97 4.14098 15.97C3.68098 14.81 3.03098 14.5 3.03098 14.5C2.12098 13.88 3.10098 13.9 3.10098 13.9C4.10098 13.97 4.63098 14.93 4.63098 14.93C5.50098 16.45 6.97098 16 7.54098 15.76C7.63098 15.11 7.89098 14.67 8.17098 14.42C5.95098 14.17 3.62098 13.31 3.62098 9.5C3.62098 8.39 4.00098 7.5 4.65098 6.79C4.55098 6.54 4.20098 5.5 4.75098 4.15C4.75098 4.15 5.59098 3.88 7.50098 5.17C8.29098 4.95 9.15098 4.84 10.001 4.84C10.851 4.84 11.711 4.95 12.501 5.17C14.411 3.88 15.251 4.15 15.251 4.15C15.801 5.5 15.451 6.54 15.351 6.79C16.001 7.5 16.381 8.39 16.381 9.5C16.381 13.32 14.041 14.16 11.811 14.41C12.171 14.72 12.501 15.33 12.501 16.26V19C12.501 19.27 12.661 19.59 13.171 19.5C17.141 18.16 20.001 14.42 20.001 10C20.001 8.68678 19.7423 7.38642 19.2398 6.17317C18.7372 4.95991 18.0006 3.85752 17.072 2.92893C16.1435 2.00035 15.0411 1.26375 13.8278 0.761205C12.6146 0.258658 11.3142 0 10.001 0Z"
      fill={props.fill || '#350174'}
    />
  </svg>
)
